import axios from "axios";
import config from "../../config";

const api = axios.create({
    baseURL: `${config.apiBaseUrl}/api`,
    timeout: 15000,
    headers: {
        "Content-Type": "application/json",
    },
});

api.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem("authToken");

        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }

        return config;
    },
    (error) => Promise.reject(error)
);

api.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response?.status === 401) {
            console.warn("Unauthorized - redirect to login");

            // clear auth
            localStorage.removeItem("authToken");
            localStorage.removeItem("user");

            // redirect user
            window.location.href = "/login";
        }

        return Promise.reject(error);
    }
);

export default api;
